import { render } from "./fournisseurdetail.vue?vue&type=template&id=30d47a08&scoped=true"
import script from "./fournisseurdetail.vue?vue&type=script&lang=js"
export * from "./fournisseurdetail.vue?vue&type=script&lang=js"

import "./fournisseurdetail.vue?vue&type=style&index=0&id=30d47a08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d47a08"]])

export default __exports__